/**
 * JeriCommerce Pass API · staging
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ProgramEngagementFlowResponseDto } from './program-engagement-flow-response-dto';


export interface EngagementFlowWithProgramEngagementFlowDto { 
    id: string;
    name: EngagementFlowWithProgramEngagementFlowDto.NameEnum;
    active: boolean;
    createdAt: string;
    updatedAt: string;
    programEngagementFlows: Array<ProgramEngagementFlowResponseDto>;
}
export namespace EngagementFlowWithProgramEngagementFlowDto {
    export const NameEnum = {
        CompleteUserProfile: 'COMPLETE_USER_PROFILE',
        Custom1: 'CUSTOM_1',
        Custom2: 'CUSTOM_2',
        Custom3: 'CUSTOM_3',
        Custom4: 'CUSTOM_4',
        Custom5: 'CUSTOM_5',
        CustomerScanned: 'CUSTOMER_SCANNED',
        FollowUs: 'FOLLOW_US',
        IncentivizePurchases: 'INCENTIVIZE_PURCHASES',
        InstallWalletPass: 'INSTALL_WALLET_PASS',
        MemberGetMember: 'MEMBER_GET_MEMBER',
        VerifyAccount: 'VERIFY_ACCOUNT',
        WalletLinkClick: 'WALLET_LINK_CLICK'
    } as const;
    export type NameEnum = typeof NameEnum[keyof typeof NameEnum];
}


